import React from "react";
import IndustryPage from "./IndustryPage";

const RetailPage: React.FC = () => {
  return <IndustryPage industryKey="retail" />;
};

export default RetailPage;
